/*
 * <cfn-reference-box-multi>
 * opens a dialog where users can select more than one line-item.
 *
 * callback function:
 * 		onselect() - is called afterwards where the selected items are returned.
 */
angular.module('cfn').directive('cfnReferenceBoxMulti', cfnReferenceBoxMulti);

function cfnReferenceBoxMulti() {
  var template =
    '<div ' +
    'class="referenceBox">' +
    '   <table class="subElement" width="100%">' +
    '       <tr>' +
    '           <td width="100%" nowrap="nowrap" style="">' +
    '				<span ng-show="field">{{nameField}}</span>' +
    '           </td>' +
    '           <td><div ng-show="readonly!=\'true\'">' +
    '               <cfn-select-reference class="imgOnly" result="result" service-param="{{serviceParam}}" pathExt="{{pathExt}}" title="{{title}}" multiselect="{{multiselect}}" onselect="onselect()" type="{{type}}" popover-path="{{popoverPath}}">' +
    '                   <img src="img/bicons/black/choose.png"/>' +
    '               </cfn-select-reference>' +
    '      </div> </td><td ng-show="readonly!=\'true\'">' +
    '            <button type="button" class="btn imgOnly" ng-show="field!=undefined" ng-click="clear()">' +
    '               <span class="farmnet-delete" />' +
    '            </button>' +
    '       </td>' +
    '       </tr>' +
    '   </table>' +
    '</div>';

  return {
    restrict: 'E',
    scope: {
      nameField: '=',
      field: '=',
      resultFunc: '&',
      title: '@',
      multiselect: '@',
      onselect: '&',
      type: '@',
      popoverPath: '@',
      serviceParam: '@',
      pathExt: '@',
      readonly: '@',
      resultParam: '@'
    },
    template: template,
    link: link
  };

  function link(scope, element, attrs) {
    attrs.$observe('type', function(value) {
      if (value) {
        // update popup path to type changes if type is an expression
        scope.popover = popups['./' + value + 'Popup.html'];

        // Don't allow to manage system entities (sysXXX)
        scope.enableBackToCore = value.indexOf('sys') !== 0;
      }
    });

    scope.clear = function() {
      if (scope.resultFunc()) {
        scope.resultFunc()({}, scope.resultParam);
      } else if (scope.onselect()) {
        scope.onselect()([]);
      }
    };
    if (scope.resultFunc()) {
      scope.result = function(ob) {
        scope.resultFunc()(ob, scope.resultParam);
      };
    }
  }
}
